<div class="subheader with-padding flgrow" style="position: relative;">
    <div class="d-flex align-items-center">
        <div class="row align-items-center flex flex-grow-1">
            <div class="col-lg-4 col-md-6 col-sm-8 maxw600">
                <div class="d-flex">
                    <div class="flex-grow-1">
                        <div class="input-group">
                            <input class="form-control" type="text" name="searchTerm"
                                placeholder="{{ 'lblQuicksearch' | translate }}" [(ngModel)]="searchTerm"
                                autocomplete="off" (keyup.enter)="onEnterPress()" />
                            <div class="input-group-append">
                                <button type="button" class="btn btn-primary" (click)="onSearchFilter()"
                                    aria-label="Center Align">
                                    <em class="fa fa-search" aria-hidden="true"></em>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="ml-2 advanced-search-box">
                        <button type="button" class="btn btn-primary" (click)="onSearch()" aria-label="Center Align">
                            <em class="fa fa-search-plus" aria-hidden="true"></em>
                        </button>
                        <div class="searchbox card fix lt width800px" *ngIf="isAdvanceSearch">
                            <div class="row mt-3">
                                <!-- Row 1: Reg No / VIN | WO No | Work Order Status -->
                                <div class="col-4 mb-3">
                                    <label translate>lblEnterRegNoOrVinNo</label>
                                    <input class="form-control" type="text" name="licensePlate"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.licensePlate"
                                        maxlength="20" autocomplete="off" />
                                </div>
                                <div class="col-4 mb-3">
                                    <label translate>lblWoNo</label>
                                    <input class="form-control" type="text" name="woNumber"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.woNumber" maxlength="15"
                                        autocomplete="off" />
                                </div>
                                <div class="col-4 mb-3">
                                    <label translate>lblWorkOrderStatus</label>
                                    <select class="form-control"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.workOrderStatusId"
                                        name="id">
                                        <option selected translate [ngValue]=null>lblSelectStatus</option>
                                        <option *ngFor="let workOrderStatus of workOrderStatusList"
                                            [ngValue]="workOrderStatus.id">
                                            {{workOrderStatus.status}}
                                        </option>
                                    </select>
                                </div>

                                <!-- Row 2: Customer Name | Mobile No | Brand -->
                                <div class="col-4 mb-3">
                                    <label translate>lblSearchByCustomerName</label>
                                    <input class="form-control" type="text" name="customerName"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.customerName"
                                        maxlength="80" autocomplete="off" />
                                </div>
                                <div class="col-4 mb-3">
                                    <label translate>lblMobileNo</label>
                                    <input class="form-control" type="text" name="mobileNumber"
                                        (keypress)="isDigit($event)"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.mobileNumber"
                                        maxlength="15" autocomplete="off" />
                                </div>
                                <div class="col-md-4 mb-3">
                                    <label translate for="template-brandGroup">lblBrand</label>
                                    <div class="lbl-info">
                                        <select class="form-control" [(ngModel)]="appointmentService.appointmentRequestModel.brandCode" name="brand">
                                            <option selected translate [ngValue]=null>lblSelectMake</option>
                                            <option *ngFor="let type of makeList" [ngValue]="type.brandCode">
                                                <span>{{type.brandName}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- Row 3: Booked Date | Created Date | Created By -->
                                <div class='col-4 mb-3'>
                                    <label translate>lblBookedDateRange</label>
                                    <div class="date">
                                        <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                                        [(ngModel)]="bookingDate" required/>
                                    </div>
                                </div>
                                <div class='col-4 mb-3'>
                                    <label translate>lblCreatedDateRange</label>
                                    <div class="date">
                                        <input bsDaterangepicker name="CreatedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
                                        [(ngModel)]="createdDate" required/>
                                    </div>
                                </div>
                                <div class='col-4 mb-3'>
                                    <label translate>lblCreatedBy</label>
                                    <div class="lbl-info">
                                        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="UserList"
                                            placeholder="{{ 'lblUsers'| translate}}" [(ngModel)]="selectedUser">
                                        </ng-multiselect-dropdown>
                                    </div>
                                </div>

                                <!-- Row 4: Select Dealer | Service Advisor | Mechanic -->
                                <div class='col-4 mb-3' *ngIf="dealerList && dealerList.length > 0">
                                    <label translate>lblSelectDealer</label>
                                    <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="dealerSelected"
                                        ngDefaultControl name="advanceDealerDropdown" [selectedDealer]="dealerId"
                                        (onSelectDealer)="onDealerSelected($event,'advanceSearchDealerDropdown')"
                                        placeholder="Search Dealer">
                                    </app-dealer-searchbox-dropdown>
                                </div>

                                <div class='col-4 mb-3'>
                                    <label translate>lblServiceAdvisors</label>
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <ng-select [(ngModel)]="serviceAdvisorSelected"
                                                [ngModelOptions]="{standalone: true}"
                                                [clearable]="!!serviceAdvisorSelected"
                                                placeholder="{{ 'lblSelectServiceAdvisor' | translate }}"
                                                [attr.title]="getSelectedServiceAdvisorName() || ('lblSelectServiceAdvisor' | translate)"
                                                ngbTooltip="{{ getSelectedServiceAdvisorName() || ('lblSelectServiceAdvisor' | translate) }}"
                                                [disabled]="!dealerId">
                                                <ng-option *ngFor="let serviceAdvisor of serviceAdvisorList" [value]="serviceAdvisor.userId" translate>
                                                    {{serviceAdvisor.userName}}
                                                </ng-option>
                                            </ng-select>
                                        </div>
                                        <div class="form-check pl-0 ml-2 mb-0">
                                            <input type="checkbox"
                                                [(ngModel)]="appointmentService.appointmentRequestModel.isAuthorizedByServiceAdvisor"
                                                [ngModelOptions]="{standalone: true}"
                                                [disabled]="!serviceAdvisorSelected" />
                                        </div>
                                    </div>
                                </div>

                                <div class='col-4 mb-3'>
                                    <label translate>lblMechanics</label>
                                    <ng-select [(ngModel)]="mechanicSelected" [ngModelOptions]="{standalone: true}" 
                                        [clearable]="!!mechanicSelected"
                                        placeholder="{{ 'lblSelectMechanic' | translate }}"
                                        [disabled]="!dealerId">
                                        <ng-option *ngFor="let mechanic of mechanics" [value]="mechanic.id"
                                            translate>
                                            {{mechanic.name}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Row 5: Type | Source | Document Part Status -->
                                <div class="col-4 mb-3">
                                    <label translate>lblAppointmenttype</label>
                                    <select class="form-control"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.appointmentType"
                                        name="appointmentType">
                                        <option translate value="" selected>lblSelectType</option>
                                        <option translate value="Order">lblOrder</option>
                                        <option translate value="Quote">lblOffer</option>
                                    </select>
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label for="template-email" translate>lblSource</label>
                                    <div class="lbl-info">
                                        <ng-multiselect-dropdown [settings]="dropdownSettings"
                                            [data]="applicationSourceList" placeholder="{{ 'lblSource'| translate}}"
                                            (onDeSelect)="onSourceDeselect()" [(ngModel)]="selectedItems">
                                        </ng-multiselect-dropdown>
                                    </div>
                                </div>

                                <div class="col-4 mb-3" *ngIf="isDocumentPartStatusActive">
                                    <label translate>lblDocumentPartStatus</label>
                                    <select class="form-control"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.documentPartStatus"
                                        name="documentPartStatus">
                                        <option selected translate [ngValue]=null>lblSelectStatus</option>
                                        <option *ngFor="let status of documentPartStatusList" [ngValue]="status.code">
                                            {{status.code}}
                                        </option>
                                    </select>
                                </div>

                                <!-- Row 6: Campaign Service | Customer Waiting | Need Attention | Towein Cars -->
                                <div class="col-4 mb-3"  *ngIf="_isShowCompainService">
                                    <label for="isCampaignService" translate>lblCampaignService</label>  
                                    <select class="form-control"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.isCampaignService"
                                        name="isCampaignService">
                                        <option selected translate [ngValue]="null">lblSelectType</option>
                                        <option translate [ngValue]="true">lblYes</option>
                                        <option translate [ngValue]="false">lblNo</option>
                                    </select>
                                </div>

                                <div class="col-4 mb-3">
                                    <label for="isCustomerWaiting" translate>lblCustomerWaiting</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="isCustomerWaiting" id="isCustomerWaiting"
                                            (change)="changeIsCustomerWaiting($event)" />
                                    </div>
                                </div>

                                <div class="col-4 mb-3"  *ngIf="_isShowTwinCar">
                                    <label for="toweinCars" translate>lblToweinCars</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="toweinCars" id="toweinCars"
                                            (change)="changeToweinCars($event)" />
                                    </div>
                                </div>

                                <!-- Row 7: Imported Car | Is Warranty Appointment | Rental Car | Tire Hotel -->
                                <div class="col-4 mb-3"  *ngIf="_isShowImportedCar">
                                    <label for="importedCar" translate>lblImportedCar</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="importedCar" id="importedCar"
                                            (change)="changeImportedCar($event)" />
                                    </div>
                                </div>

                                <div class="col-4 mb-3">
                                    <div [ngClass]="isWarrantyAppointment ? 'col-6 form-check pl-0 mb-0' : 'col-12 form-check pl-0 mb-0'">
                                        <label for="isWarrantyAppointment" translate>lblIsWarrantyAppointment</label>
                                        <input type="checkbox" [checked]="isWarrantyAppointment" id="isWarrantyAppointment"
                                            (change)="changeIsWarrantyAppointment($event)" />
                                    </div>
                                    <div class="col-6 form-check pl-0 mb-0" *ngIf="isWarrantyAppointment">
                                        <label for="isWarrantyDocumentSigned" translate>lblIsWarrantyDocumentSigned</label>  
                                        <select class="form-control" [(ngModel)]="appointmentService.appointmentRequestModel.isWarrantyDocumentSigned"
                                            name="isWarrantyDocumentSigned">
                                            <option selected translate [ngValue]="null">lblSelectType</option>
                                            <option translate [ngValue]="true">lblYes</option>
                                            <option translate [ngValue]="false">lblNo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-2 mb-3" *ngIf="isRentalcarActive">
                                    <label for="customCheck1" translate>lblRentalCar</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="isRentalCar" id="customCheck1" (change)="changeRentalCarType($event)" />
                                    </div>
                                </div>

                                <div class="col-2 mb-3" *ngIf="isTireHotelActive">
                                    <label for="customCheck1" translate>lblTireHotel</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="isTireHotel" id="customCheck1" (change)="changeTireHotel($event)" />
                                    </div>
                                </div>

                                <!-- Conditional fields -->
                                <div class="col-4 mb-3" *ngIf="isShowDMSStatus">
                                    <label translate>lblAppointmentStatus</label>
                                    <select class="form-control"
                                        [(ngModel)]="appointmentService.appointmentRequestModel.appointmentStatusId"
                                        name="id">
                                        <option selected translate [ngValue]=null>lblSelectStatus</option>
                                        <option *ngFor="let status of appointmentstatusList" [ngValue]="status.id">
                                            {{status.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-4 mb-3" *ngIf="isNeedAttentionActive">
                                    <label for="needAttention" translate>lblNeedAttention</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="needAttention" id="needAttention"
                                            (change)="changeNeedAttention($event)" />
                                    </div>
                                </div>

                                <div class="col-4 mb-3" *ngIf="isOfferFeatureActive">
                                    <label for="customCheck3" translate>lblCurrentOffer</label>
                                    <div class="form-check pl-0">
                                        <input type="checkbox" [checked]="currentOffer" id="customCheck3" (change)="changeCurrentOffer($event)" />
                                    </div>
                                </div>
                            </div>
                            
                            <hr />
                            <div class="row">
                                <div class="col text-left">
                                    <button type="submit" (click)="OpenSaveSearchModal(SaveSearchContent)"
                                        aria-label="Center Align" class="btn btn-primary mr-sm-2 mb-1"
                                        translate>lblSaveFilter
                                    </button>
                                </div>
                                <div class="col-auto me-auto text-right">
                                    <button type="submit" (click)="AdvanceSearchSubmit()" aria-label="Center Align"
                                        class="btn btn-primary mr-sm-2" translate>lblApply
                                    </button>
                                    <button (click)="onReset()" aria-label="Center Align"
                                        class="btn btn-outline-tertiary mr-sm-2" translate>lblReset
                                    </button>
                                    <button (click)="onClose()" aria-label="Center Align"
                                        class="btn btn-outline-tertiary" translate>lblClose
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto pl-0">
                <button type="submit" (click)="OpenSavedSearchListPopup()" class="btn btn-primary" translate
                    aria-label="Center Align">lblSavedFilters</button>
            </div>
            <div class="col pl-0">
                <div class="row align-items-center">
                    <div class="col-lg-4 col-sm-6 col-md-6 mb-3 mb-lg-0 pl-2"
                        *ngIf="dealerList && dealerList.length > 0">
                        <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="dealerSelected"
                            ngDefaultControl name="dealerDropdown" [selectedDealer]="dealerId"
                            (onSelectDealer)="onDealerSelected($event,'dealerDropdown')" placeholder="Search Dealer"
                            style="width: 200px;">
                        </app-dealer-searchbox-dropdown>
                    </div>
                    <div class="col-lg-3 col-sm-6 col-md-6 mb-3 mb-lg-0" *ngIf="integrationWithDMS">
                        <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
                            (change)="SyncChange($event)">
                            <ng-option *ngFor="let status of SyncList" [value]="status.id">
                                {{status.value}}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-lg-5 col-sm-6 col-md-6 mb-3 mb-lg-0"
                        *ngIf="appointmentDayList && appointmentDayList.length > 0">
                        <ng-select placeholder="{{ 'lblAppointmentDay' | translate }}" [(ngModel)]="appointmentDay"
                            (change)="ChangeAppointmentDay()">
                            <ng-option *ngFor="let ad of appointmentDayList" [value]="ad.dayCode">
                                {{ad.name | translate}}
                            </ng-option>
                        </ng-select>
                    </div>

                </div>
            </div>

        </div>
        <div class="pl-2 d-flex align-items-center flex-sm-row flex-column justify-content-end ml-auto">

            <button type="button" (click)="exportAsXLSX(documentTypes.Excel)"
                ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align">
                <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
            </button>
            <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
                ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
                <em class="far fa-file fa-2x"></em>
                <span class="bdg">PDF</span>
            </button>
            <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()"
                aria-label="Center Align">
                <em class="fas fa-sync fa-lg"></em>
            </a>
            <button type="button" *ngIf="userRoleRightsDetails.canAdd" (click)="OpenAddAppointmentModel()" type="reset"
                aria-label="Center Align" class="ml-3 add-button btn btn-primary" translate>lblAddAppointment</button>
        </div>
    </div>
</div>

<div class="container">
    <div class="row">
        <div class="c12 mb7">
            <div class="card with-padding card-shadow">
                <div class="form-row mb-2 align-items-center" *ngIf="appointmentstatusList?.length>0">
                    <div class="col maxw100 mbold" translate *ngIf="isShowDMSStatus">lblStatus</div>
                    <div class="col">
                        <div class="form-row">
                            <div *ngIf="isShowDMSStatus">
                                <div class="col-auto status-column" 
                                    [class.active]="list.id==appointmentService.appointmentRequestModel.appointmentStatusId"
                                    [style.border-color]="list.color" *ngFor="let list of appointmentstatusList;"
                                    [style.background-color]="list.id==appointmentService.appointmentRequestModel.appointmentStatusId ? '#ded8db' : ''">
                                    <div class="d-flex flex-row p-1 mb-1" (click)="GetAppointmentStatusList(list.id,1)">
                                        <span class="color-box" [style.background-color]="list.color"></span>
                                        <span class="status-name">{{list.name}}</span>
                                        <span class="status-count">-&nbsp;{{list.statusCount}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto ml-auto">
                                <button type="submit" (click)="onClearFilter()" class="ml-3 add-button btn "
                                    [ngClass]="isFilterApplied ? 'btn-danger' : 'btn-primary'" placement="bottom" aria-label="Center Align"
                                    translate>lblClearFilters </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-row" *ngIf="workOrderStatusList?.length>0;">
                    <div class="col maxw100 mbold mt-2-5" translate>lblWoStatus</div>
                    <div class="col">
                        <div class="form-row">
                            <div class="col-auto status-column"
                                [class.active]="list.id==appointmentService.appointmentRequestModel.workOrderStatusId"
                                [style.background-color]="list.id==appointmentService.appointmentRequestModel.workOrderStatusId ? '#ded8db' : ''"
                                [style.border-color]="list.color" *ngFor="let list of workOrderStatusList;">
                                <div class="d-flex flex-row p-1 mb-1" (click)="GetAppointmentStatusList(list.id,2)">
                                    <span class="color-box" [style.background-color]="list.color"></span>
                                    <span class="status-name">{{list.status}}</span>
                                    <span class="status-count">-&nbsp;{{list.statusCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="prel container">
    <div class="row">
        <div class="c12">
            <div class="card">
                <div class="card-header d-flex justify-content-between" translate>
                    lblAppointment
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>

                <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false"
                    (scrolled)="loadMoreData($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width:0.5%" scope="col">#</th>
                                <th style="width:5%" scope="col" translate class="">lblType</th>
                                <th style="width:5%" scope="col" translate>lblWoNo</th>
                                <th style="width:5%" scope="col" translate class="text-center">lblWoStatus</th>
                                <th style="width:17%" scope="col" sortable="licensePlate" (sort)="onSort($event)"
                                    translate>lblRegNumber
                                </th>

                                <th style="width:5%" scope="col" translate>lblSource</th>
                                <th style="width:23%" class="ST" scope="col" sortable="customerName"
                                    (sort)="onSort($event)" translate>
                                    lblCustomer
                                </th>
                                <th style="width:25%" scope="col" sortable="dealerName" (sort)="onSort($event)"
                                    translate>lblDealersName</th>
                                <th style="width:7%" scope="col" sortable="bookedDateTime" (sort)="onSort($event)"
                                    translate>lblBookedDate</th>
                                <th style="width:7%" scope="col" *ngIf="isPlannedAndAvailableHours" translate>
                                    lblPlannedVsAvailableHours</th>
                                <th style="width:15%" scope="col" sortable="createdDateTime" (sort)="onSort($event)"
                                    translate>lblCreatedDate</th>
                                <th style="width:5%" scope="col" translate>lblServiceContract</th>
                                <th style="width:5%" scope="col" *ngIf="isRentalcarActive" translate>lblRentalCar</th>
                                <th style="width:5%" scope="col" translate *ngIf="isNeedAttentionActive">lblNeedAttention</th>
                                <th style="width:5%" scope="col" translate *ngIf="isOfferFeatureActive">lblAppointmentOffer</th>
                                <th style="width:5%" scope="col" translate class="text-center" *ngIf="isShowDMSStatus">lblStatus</th>

                                <th scope="col" style="width:150px" translate class="text-center">lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="appointmentList?.length>0; else load_else">
                                <tr *ngFor="let appointment of appointmentList; let i=index">
                                    <td class="click" (click)="OpenEditView(appointment)">{{ appointment.rowNumber }}
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight [result]="appointment.appointmentType"
                                            [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="app-wo-customerwaiting">
                                            <div>
                                                <div *ngIf="appointment.isCustomerWaiting === true" class="d-flex align-items-center">
                                                    <em class="fas fa-clock mr-2"></em> {{appointment.workOrderNo}}
                                                </div>
                                                <div *ngIf="appointment.isCustomerWaiting === false">
                                                    {{appointment.workOrderNo}}
                                                </div>
                                            </div>
                                            <div class="widget-appointment-no" *ngIf="appointment.widgetAppointmentNo">
                                                #{{ appointment.widgetAppointmentNo }}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="position-relative click" (click)="OpenEditView(appointment)">
                                        <div class="mx-auto text-center">
                                            <div class="color-box" [ngbTooltip]="appointment.workOrderStatus"
                                                tooltipClass="tooltip-inner-width"
                                                [style.background-color]="appointment.workOrderStatusColor">
                                            </div>
                                        </div>
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{appointment.licensePlate}}
                                            </div>
                                            <div class="imgWid">
                                                <img af-brand-logo [data-code]="appointment.brandCode" data-type="BRAND"
                                                    class="{{appointment.brandCode}}-icon common"
                                                    [title]="appointment.brandCode" class="brandicon" alt="img" />
                                            </div>
                                        </div>
                                        <div class="mt-1">
                                            <ngb-highlight class="flmid semibold fs-12px lh-16px"
                                                [result]="appointment.modelName" [term]="pService.searchTerm">
                                            </ngb-highlight>
                                        </div>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight class="flmid sourceBox rounded-0 justify-content-center"
                                            [result]="appointment.sourceCreation" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight class="fs-14px semibold lh-18px d-block"
                                            [result]="appointment.customerName" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                        <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                            <em _ngcontent-xdg-c220=""
                                                class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                            <span class="fs-12px"
                                                *ngIf="appointment && appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                                            <ngb-highlight class="fs-12px" [result]="appointment.mobileNo"
                                                [term]="pService.searchTerm">
                                            </ngb-highlight>
                                        </div>

                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="">
                                            <div class="">
                                                <ngb-highlight [result]="appointment.dealerName" [term]="pService.searchTerm">
                                                </ngb-highlight>
                                            </div>
                                            <ngb-highlight class="fs-12px lh-18px d-block" [class.font-weight-bold]="appointment.isAuthorizedByServiceAdvisor" [result]="appointment.serviceAdvisorName" [term]="pService.searchTerm">
                                            </ngb-highlight>
                                        </div>
                                    </td>

                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <ngb-highlight [result]="appointment.bookedDate" [term]="pService.searchTerm">
                                        </ngb-highlight>
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)"
                                        *ngIf="isPlannedAndAvailableHours">
                                        {{ appointment.serviceTime }} / {{ appointment.allocatedTime }} / {{
                                        appointment.plannedTime }}
                                    </td>
                                    <td class="click" (click)="OpenEditView(appointment)">
                                        <div class="">
                                            <div class="">
                                                {{ appointment.createdDateTime | date:'short'}}
                                            </div>
                                            <ngb-highlight *ngIf="isUserDropdown" class="fs-12px lh-18px d-block"
                                                [result]="appointment.userName">
                                            </ngb-highlight>
                                        </div>
                                    </td>
                                    <td class="text-center click" (click)="OpenEditView(appointment)">
                                        <em class="fas fa-check fa-lg"
                                            *ngIf="appointment.isServiceContractVehicle === true"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="appointment.isServiceContractVehicle === false"></em>
                                    </td>
                                    <td class="text-center click" (click)="OpenEditView(appointment)"
                                        *ngIf="isRentalcarActive">

                                        <em class="fas fa-check fa-lg"
                                            *ngIf="appointment.isRentalCarRequired === true"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="appointment.isRentalCarRequired === false"></em>
                                    </td>
                                    <td class="text-center click" (click)="OpenEditView(appointment)" *ngIf="isNeedAttentionActive">

                                        <em class="fa fa-exclamation-triangle text-warning fa-lg"
                                            *ngIf="appointment.needAttention === 1"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="appointment.needAttention === 0"></em>
                                        <em class="fas fa-check fa-lg" *ngIf="appointment.needAttention === 2"></em>

                                    </td>

                                    <td class="text-center click" (click)="OpenEditView(appointment)" *ngIf="isOfferFeatureActive">

                                        <em class="fas fa-check fa-lg" *ngIf="appointment.currentOffer === true"></em>
                                        <em class="fas fa-times text-danger fa-lg cursordisable"
                                            *ngIf="appointment.currentOffer === false"></em>

                                    </td>

                                    <td class="position-relative click" (click)="OpenEditView(appointment)" *ngIf="isShowDMSStatus">
                                        <div class="mx-auto text-center">
                                            <ng-container *ngFor="let status of appointmentstatusList">
                                                <ng-container *ngIf="appointment.appointmentStatusId === status.id">
                                                    <div class="color-box" [ngbTooltip]="status.name"
                                                        [style.background-color]="appointment.appointmentStatusColor">
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </td>

                                    <td class="nowrap text-center">
                                        <a class="btn btn-ico" *ngIf="appointment.reasonForCancellation"
                                            ngbTooltip="{{appointment.reasonForCancellation}}">
                                            <em class="fas fa-times-circle fa-lg"></em>
                                        </a>
                                        <span class="ico-div" *ngIf="appointment.reasonForCancellation"></span>
                                        <ng-container *ngIf="integrationWithDMS && !appointment.isFromArchive">
                                            <a class="btn btn-ico" ngbTooltip="{{ 'lblSyncToDMS' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="(appointment.dmsSyncStatus != 0 || appointment.appointmentType != 'Order')"
                                                (click)="onSyncToDms(appointment.id, appointment.appointmentGuid)">
                                                <em class="fas fa-sync fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="appointment.dmsSyncStatus != 0  || appointment.appointmentType != 'Order'"></span>
                                            <a class="btn btn-ico" ngbTooltip="{{ 'lblDMSSyncFailedlog' | translate }}"
                                                tooltipClass="custom-revert"
                                                [class.invisible]="appointment.dmsSyncStatus != 0  || appointment.appointmentType != 'Order'"
                                                (click)="viewException(appointment.id)">
                                                <em class="fas fa-clipboard-list fa-lg  "></em>
                                            </a>
                                            <span class="ico-div"
                                                [class.invisible]="appointment.dmsSyncStatus != 0  || appointment.appointmentType != 'Order'"></span>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="!appointment.isEditable || appointment.isFromArchive; else load_else">
                                            <ng-container>
                                                <a class="btn btn-ico"
                                                    *ngIf="userRoleRightsDetails.canView; else disabledView"
                                                    (click)="onView(appointment)"
                                                    ngbTooltip="{{'lblView' | translate}}">
                                                    <em class="far fa-eye fa-lg"></em>
                                                </a>
                                                <ng-template #disabledView>
                                                    <a class="btn btn-ico disabled"
                                                        ngbTooltip="{{'lblView' | translate}}"
                                                        tooltipClass="custom-revert">
                                                        <em class="far fa-eye fa-lg"></em>
                                                    </a>
                                                </ng-template>
                                            </ng-container>

                                            <span class="ico-div"></span>
                                            <ng-container>
                                                <a class="btn btn-ico "
                                                    *ngIf="userRoleRightsDetails.canDelete && appointment.isDeletable && !appointment.isFromArchive; else disabledDelete"
                                                    (click)="DeleteAppointment(appointment)"
                                                    ngbTooltip="{{'lblDelete' | translate}}"
                                                    tooltipClass="custom-revert">
                                                    <em class="far fa-trash-alt fa-lg"></em>
                                                </a>
                                                <ng-template #disabledDelete>
                                                    <a class="btn btn-ico disabled"
                                                        ngbTooltip="{{'lblDelete' | translate}}"
                                                        tooltipClass="custom-revert">
                                                        <em class="far fa-trash-alt fa-lg text-muted"></em>
                                                    </a>
                                                </ng-template>
                                            </ng-container>
                                            <span class="ico-div"></span>
                                            <a class="btn btn-ico"
                                                *ngIf="!appointment.isFromArchive; else disabledUpdateStatus"
                                                ngbTooltip="{{'lblUpdateStatus' | translate}}" placement="left"
                                                (click)="open(mymodal, appointment)">
                                                <em class="fas fa-clipboard-check fa-lg"></em>
                                            </a>
                                            <ng-template #disabledUpdateStatus>
                                                <a class="btn btn-ico disabled"
                                                    ngbTooltip="{{'lblUpdateStatus' | translate}}"
                                                    tooltipClass="custom-revert">
                                                    <em class="fas fa-clipboard-check fa-lg"></em>
                                                </a>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #load_else>
                                            <ng-container>
                                                <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}"
                                                    *ngIf="userRoleRightsDetails.canEdit && appointment.isEditable; else disabledEdit"
                                                    (click)="onEdit(appointment)">
                                                    <em class="fas fa-pencil-alt fa-lg"></em>
                                                </a>
                                                <ng-template #disabledEdit>
                                                    <a class="btn btn-ico disabled"
                                                        ngbTooltip="{{'lblEdit' | translate}}"
                                                        tooltipClass="custom-revert">
                                                        <em class="fas fa-pencil-alt fa-lg"></em>
                                                    </a>
                                                </ng-template>
                                            </ng-container>

                                            <span class="ico-div"></span>
                                            <ng-container>
                                                <a class="btn btn-ico "
                                                    *ngIf="userRoleRightsDetails.canDelete && appointment.isDeletable; else disabledEditDelete"
                                                    (click)="DeleteAppointment(appointment)"
                                                    ngbTooltip="{{'lblDelete' | translate}}"
                                                    tooltipClass="custom-revert">
                                                    <em class="far fa-trash-alt fa-lg"></em>
                                                </a>
                                                <ng-template #disabledEditDelete>
                                                    <a class="btn btn-ico disabled"
                                                        ngbTooltip="{{'lblDelete' | translate}}"
                                                        tooltipClass="custom-revert">
                                                        <em class="far fa-trash-alt fa-lg text-muted"></em>
                                                    </a>
                                                </ng-template>
                                            </ng-container>

                                            <span class="ico-div"></span>
                                            <a class="btn btn-ico" ngbTooltip="{{'lblUpdateStatus' | translate}}"
                                                placement="left">
                                                <em class="fas fa-clipboard-check fa-lg"
                                                    (click)="open(mymodal, appointment)"></em>
                                            </a>
                                        </ng-template>
                                        <span class="ico-div" *ngIf="isWhatsappFeatureActive"></span>
                                        <a class="btn btn-ico whatsapp-icon-container" ngbTooltip="{{'lblWhatsAppMessages' | translate}}" placement="left"
                                            *ngIf="isWhatsappFeatureActive">
                                            <em class="fab fa-whatsapp fa-lg" (click)="openWhatsAppMessagesTab(appointment)"></em>
                                            <span class="badge badge-pill badge-warning whatsapp-message-circle"
                                                *ngIf="appointment.whatsAppUnrepliedCount > 0">{{
                                                appointment.whatsAppUnrepliedCount }}</span>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="" style="display: none; margin-top: 300px;">
    <div class="container" style="background-color: blue;">
        <div class="row mb-30">
            <div class="col-12">
                <div class="row pl-5 pr-5 pt-3 pb-3">
                    <div class="col-md-5">
                        <img class="brand" src="assets/images/sy-logo.png"
                            onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'" alt=""
                            height="70" style="width:300px">
                    </div>
                    <div class="col-md-7">
                        <div class="Invoice_title" style="float: left;">
                            <p class="font-weight-bold" style="font-size:24px; color: white;">Appointment List</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <table class="table mt-100" id="PDFdata">
        <thead class="">
            <tr class="table-primary" style="font-size: small">
                <th style="width:3%" scope="col" style="font-weight: bold;">#</th>
                <th style="width:5%" scope="col" translate style="font-weight: bold;">lblAppointmentType</th>
                <th style="width:10%" scope="col" translate style="font-weight: bold;">lblRegNumber</th>
                <th style="width:11%" scope="col" translate style="font-weight: bold;">lblCarModel</th>
                <th style="width:10%" scope="col" translate style="font-weight: bold;">lblBrandName</th>
                <th style="width:15%" scope="col" translate style="font-weight: bold;">lblDealerName</th>
                <th style="width:15%" scope="col" translate style="font-weight: bold;">lblCustomerName</th>
                <th style="width:15%" scope="col" translate style="font-weight: bold;">lblMobileNo</th>
                <th style="width:8%" scope="col" translate style="font-weight: bold;">lblWoNo</th>
                <th style="width:8%" scope="col" translate style="font-weight: bold;">lblWoStatus</th>
                <th style="width:8%" scope="col" translate style="font-weight: bold;">lblBookedDate</th>
                <th style="width:5%" scope="col" translate style="font-weight: bold;">lblStatus</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="appointmentListPDF?.length>0; else load_else">
                <tr *ngFor="let appointment of appointmentListPDF; let index=index">
                    <td>{{ index+1}}</td>
                    <td>
                        <ngb-highlight [result]="appointment.appointmentType" [term]="pService.searchTerm">
                        </ngb-highlight>
                    </td>
                    <td>
                        <div class="flmid">
                            <div class="licplate LPNo">{{appointment.licensePlate}}</div>
                        </div>
                    </td>
                    <td>
                        <div class="flmid">
                            <ngb-highlight [result]="appointment.modelName" [term]="pService.searchTerm">
                            </ngb-highlight>
                        </div>
                    </td>
                    <td>
                        <ngb-highlight [result]="appointment.brandName" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="appointment.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="appointment.customerName" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td class="text-nowrap">
                        <span *ngIf="appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                        <ngb-highlight [result]="appointment.mobileNo" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="appointment.workOrderNo" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td class="position-relative">
                        <ngb-highlight [result]="appointment.workOrderStatus"></ngb-highlight>
                    </td>
                    <td>
                        <ngb-highlight [result]="appointment.bookedDate" [term]="pService.searchTerm">
                        </ngb-highlight>
                    </td>
                    <td class="position-relative">
                        <ng-container *ngFor="let status of appointmentstatusList">
                            <ng-container *ngIf="appointment.appointmentStatusId === status.id">
                                <ngb-highlight [result]="status.name | lowercase"></ngb-highlight>
                            </ng-container>
                        </ng-container>
                    </td>

                </tr>
            </ng-container>
            <ng-template #load_else>
                <tr>
                    <td colspan="8" translate>lblNoRecordsFound</td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</div>
<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblUpdateWOStatus</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row" *ngIf="isOpenByOtherUser">
            <div class="col-12">
                <div class="alert alert-warning font18 text-center p-2 mb-2">{{isOpenByOtherUserMsg}}</div>
            </div>
        </div>
        <div class="card pad15">
            <div class="row" *ngIf="updateAppointmentStatusModel">
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblCustomerName</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.customerName}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblWoNo</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.WOnumber}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblDealerName</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.dealerName}}</div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblWoStatus</label>
                        <div class="lbl-info">
                            <span class="color-box"
                                [style.background-color]="updateAppointmentStatusModel.WOstatusColor"></span> &nbsp;
                            <span>{{updateAppointmentStatusModel.WOstatus}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblRegNumber</label>
                        <div class="lbl-info flmid">
                            <div class="licplate LPNo d-flex">
                                <span class="icn-flag"></span> {{updateAppointmentStatusModel.licensePlate}}
                            </div>
                            <div class="imgWid">
                                <img af-brand-logo data-type="BRAND" [data-code]="updateAppointmentStatusModel.brandImg" class="brandicon" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6"
                    *ngIf="updateAppointmentStatusModel && updateAppointmentStatusModel.WOstatusId !== 10">
                    <label translate>lblNewWOStatusTo</label>
                    <div class="lbl-info">
                        <ng-select [(ngModel)]="SelectedStatus" [ngModelOptions]="{standalone: true}"
                            placeholder="{{ 'lblSelectStatus' | translate }}" (change)="onStatusChange()">
                            <ng-option *ngFor="let status of statusList" [value]="status.id">
                                {{status.name}}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-6 mt-3">
                    <div class="af-form-group">
                        <label translate>lblModel</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.model}}</div>
                    </div>
                </div>
                <div class="col-6 mt-3">
                    <div class="af-form-group">
                        <label translate>lblAppointmentStatus</label>
                        <div class="lbl-info">
                            <span class="color-box"
                                [style.background-color]="updateAppointmentStatusModel.appointmnetStatusColor"></span>
                            &nbsp;
                            <span>{{updateAppointmentStatusModel.appointmentStatus}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="af-form-group" *ngIf="isDisplayInvoice">
                        <div class="form-check pl-0">
                            <label translate>lblFinalInvoice</label>
                            <div class="lbl-info relative km-block">
                                <input type="text" class="form-control text-right" id="name" maxlength="10" required
                                    #name="ngModel" [ngModel]="InvoicePrice | toNumber | number: '1.2-2'"
                                    pattern="^[\d,.\s]+$" (blur)="onBlur($event)" />
                            </div>
                            <div *ngIf="name.invalid && (name.dirty || name.touched)"
                                class="help-block mt-1 text-danger">
                                <div class="help-block mt-1 text-danger" translate>
                                    lblPleaseEnterTheValidValue
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="af-form-group">
                        <label translate>lblBookedDate</label>
                        <div class="lbl-info">{{updateAppointmentStatusModel.bookDate}}</div>
                    </div>
                </div>


            </div>
        </div>

    </div>

    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="updateStatus()"
                *ngIf="updateAppointmentStatusModel && updateAppointmentStatusModel.WOstatusId !== 10"
                aria-label="Center Align" [disabled]="!SelectedStatus || isOpenByOtherUser">lblUpdate</button>
            <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>


<ng-template #SaveSearchContent let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblSaveFilter</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">

            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0 ">
        <div class="popup-vcenter ">
            <div class="flgrow">
                <div class="pad15">
                    <div class="form-row">
                        <div class='col-5'>
                            <label translate>lblSearchName</label><strong class="mlt6 required"> * </strong>
                            <div class="">
                                <input class="form-control" type="text" name="SearchName" [formControl]="control"
                                    [(ngModel)]="saveSearchFilter.filterName" maxlength="200" autocomplete="off"
                                    placeholder="{{ 'lblEnterSearchName' | translate }}" />
                                <div *ngIf="!saveSearchFilter.filterName && control.touched" style="color: red;"
                                    class="cst-validation-msg">
                                    <em class="fa fa-exclamation-circle" aria-hidden="true">&nbsp;&nbsp;</em><span
                                        translate>lblSearchNameRequired</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="form-row">
                        <div class="col-12">
                            <p class="title16 mb-2" translate>lblParameterValues</p>
                            <div class="row">
                                <div class='col-4 mb-2' *ngFor="let search of saveSearchFilter.saveSearchArray">
                                    <div class="px-3">
                                        <em class="fa fa-chevron-right mr-2"></em>
                                        <span class="bold">{{search.searchColumnName | translate}}</span> :
                                        {{search.searchActualValue}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="submit" [disabled]="!saveSearchFilter.filterName" class="btn btn-primary mr-sm-2" translate
            (click)="control.markAsTouched();SaveAdvanceSearchFilter();" aria-label="Center Align">lblSave</button>

        <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
            translate>lblCancel</button>
    </div>
</ng-template>